module.exports = __webpack_public_path__ + "img/banner_2.d04ce19e.jpg";